/* cart/setCartVisibility
 ========================================================================== */
import { isDesktopDisplay } from '../mobile/check';
export function setCartVisibility(cart) {
    if (!cart) {
        return;
    }
    const delay = 10000;
    const showCart = () => cart.classList.add('is-visible');
    const hideCart = () => cart.classList.remove('is-visible');
    // On desktop, reveal the header if it was hidden by scroll.
    if (isDesktopDisplay()) {
        const header = document.querySelector('.header');
        if (header?.classList.contains('header--invisible')) {
            header.classList.remove('header--invisible');
            header.classList.add('header--visible');
        }
    }
    window.setTimeout(() => hideCart(), delay);
    showCart();
    cart.addEventListener('mouseover', hideCart);
}
